import { appStorageService, encore } from '@saucelabs/sl-util-axios';

export const fetchMetadata = (page = 'manual') => (
  encore.get(`/api/page_metadata/${page}`)
);
export const putMetadata = (page = 'manual', key, data) => (
  encore.put(`/api/page_metadata/${page}/${key}`, data)
);

export const fetchAppInfo = (appId) => (
  appStorageService.get(`/v1/storage/files/${appId}/info`)
);
